import { gql } from '@apollo/client';

/**
 * GraphQL query to get a single standard policy by ID
 */
export const GET_STANDARD_POLICY = gql`
  query StandardPolicy($id: ID!) {
    standardPolicy(id: $id) {
      id
      communityId
      name
      description
      isEnabled
      labels {
        labelId
        severity
        scoreThreshold
      }
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
      scope
      isSystemManaged
      sourcePolicyId
    }
  }
`;
